import type { BasketEntry } from '../../outbox/types'

export interface AssignResultState {
  palletCode: string
  opIds: string[]
  basketEntries: BasketEntry[]
}

/** Navigation state is volatile, so invalid direct visits get a readable empty result. */
export function readAssignResultState(value: unknown): AssignResultState | null {
  if (typeof value !== 'object' || value === null) {
    return null
  }

  const candidate = value as {
    palletCode?: unknown
    opIds?: unknown
    basketEntries?: unknown
  }

  if (
    typeof candidate.palletCode !== 'string' ||
    !Array.isArray(candidate.opIds) ||
    !candidate.opIds.every((opId): opId is string => typeof opId === 'string') ||
    !Array.isArray(candidate.basketEntries) ||
    !candidate.basketEntries.every(isBasketEntry)
  ) {
    return null
  }

  return {
    palletCode: candidate.palletCode,
    opIds: candidate.opIds,
    basketEntries: candidate.basketEntries,
  }
}

function isBasketEntry(value: unknown): value is BasketEntry {
  if (typeof value !== 'object' || value === null) {
    return false
  }

  const candidate = value as Partial<BasketEntry>

  return (
    typeof candidate.serialNumber === 'string' &&
    (candidate.captureMethod === 'camera' || candidate.captureMethod === 'manual') &&
    typeof candidate.capturedAt === 'string' &&
    typeof candidate.seq === 'number'
  )
}
